import actionTypes from '../actionTypes';
export default {
  setTeamList: data => dispatch => {
    dispatch({
      type: actionTypes.PROFILE_TEAM_LIST,
      payload: data
    });
  },
  setTeam: data => dispatch => {
    dispatch({
      type: actionTypes.PROFILE_TEAM,
      payload: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/store/action/profile.action.js